import { render, staticRenderFns } from "./ClientOwnedVendorGroup.vue?vue&type=template&id=6366a40e&scoped=true&"
import script from "./ClientOwnedVendorGroup.vue?vue&type=script&lang=js&"
export * from "./ClientOwnedVendorGroup.vue?vue&type=script&lang=js&"
import style0 from "./ClientOwnedVendorGroup.vue?vue&type=style&index=0&id=6366a40e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6366a40e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCard,VCardText,VCardTitle,VChip,VIcon,VSpacer,VTooltip})
